// extracted by mini-css-extract-plugin
export default {"achievementcard":"achievementcard_achievementcard__W7bU6","wrapper":"achievementcard_wrapper__gSIyx","image":"achievementcard_image__c7od9","text":"achievementcard_text__gmToK"};